module.exports = __webpack_public_path__ + "img/hr-deepwater2.49077f13.png";